// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { EntitlementHistory, EntitlementProductFilter, getEntitlementProductFilterKey } from '@shared/commons/cache/Entitlement/EntitlementPrimitives';
import { EntitlementCategoryProduct, NO_NAME_CATEGORY } from '@shared/commons/cache/Entitlement/EntitlementCategoryProduct';
import { HtmlScroll } from '@components/webdesktop/elements/Scroll/HtmlScroll';
import TerceraProductsPanelTemplate from '@front/templates/TerceraProductsPanelTemplate.html';
import PanelSideBarBaseNoDataPartial from '@front/templates/PanelSideBarBaseNoDataPartial.html';
import { EntitlementProductsItem } from '../cache/EntitlementProductsItem';
import { DockPlaceConst, DockSystemInstance } from '../DockSystem';
import { PanelNames } from '../UtilsClasses/FactoryConstants';
import { DynProperty } from '@shared/commons/DynProperty';
import { EntitlementManager } from '@shared/commons/cache/Entitlement/EntitlementManager';
import { DataCache } from '@shared/commons/DataCache';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { WorkSpaceManager } from '../WorkSpace/WorkSpaceManager';
import { ApplicationPanelWithTable } from './ApplicationPanelWithTable';
import { createContextMenuItemsFromEnum } from '@shared/utils/ContextMenuUtils';
export class ProductsPanel extends ApplicationPanelWithTable {
    constructor() {
        super();
        this.NeedCalculateRowCount = false;
        this.headerLocaleKey = 'screen.products.Products';
        this.rangeSelectPanel = null;
        this.toolbarSelectedFilter = EntitlementProductFilter.All;
        this.cachedAllProductCount = null;
        this.myMsgBox = null;
        this.onSelectedFilterValueChanged = (context, newValue) => {
            this.toolbarSelectedFilter = newValue;
            this.setProductsData();
            this.resetScroll();
        };
    }
    getType() {
        return PanelNames.ProductsPanel;
    }
    oncomplete() {
        super.oncomplete();
        this.addRangeSelectPanel();
        this.on('clickCheck', this.clickCheck);
        this.on('scrolling_left_Click', this.scrollingLeftClick);
        this.on('scrolling_right_Click', this.scrollingRightClick);
        this.observe('checkedCategories', this.observeActive);
        this.observe('checkedRequest', this.observeRequest);
        // this.observe('categories', this.sortingProductCatalog);   // вот тут точно что то сломаю но так часто сортировать нельзя
        this.on('onCollapserClick', this.onCollapserClick);
        this.setProductsData();
        this.addScroll();
        this.createToolbar();
        this.localize();
        this.layoutTable();
        this.center();
        DataCache.EntitlementManager.OnAddOrUpdate.Subscribe(this.OnAddOrUpdateProduct, this);
        const qt = this.getQuickTable();
        qt.AddToEnd = false;
        qt.OnPaintedPictureButtonClick.Subscribe(this.CancelBTNClick, this);
    }
    addRangeSelectPanel() {
        const topPanel = this.Controls.productPanelRangeSelect;
        topPanel.getReportEvent.Subscribe(this.getProductRequests, this);
        topPanel.updateSelectedRange();
        this.rangeSelectPanel = topPanel;
    }
    layoutTable(noChanges = false) {
        if (noChanges) {
            return;
        }
        const showHeader = this.get('showHeader');
        const heightHeader = showHeader ? ProductsPanel.HEADER_PANEL : 0;
        const heightPanel = this.get('height');
        const height = heightPanel -
            heightHeader -
            ProductsPanel.SWITCH_MENU -
            ProductsPanel.TOOLBAR_HEIGHT -
            ProductsPanel.PADDING;
        void this.set({ heightSubscriptionsPanel: height });
        if (this.quickTableRactive === null) {
            return;
        }
        const topMargin = ProductsPanel.SWITCH_MENU + ProductsPanel.TOOLBAR_HEIGHT;
        const scrWidth = this.get('width');
        const scrHeight = this.get('height');
        this.quickTableRactive.setBounds(0, 0, Math.abs(scrWidth), Math.abs(scrHeight - topMargin - heightHeader));
        const categories = this.get('categories');
        if (!isNullOrUndefined(categories)) {
            for (const object in categories) {
                categories[object].SetAvaliableWidth(this.get('width') -
                    (ProductsPanel.ARROW_CONTAINER_SIZE + ProductsPanel.GAP_BTW_ARROW + ProductsPanel.PADDING) * 2);
            }
            void this.set({ categories });
        }
    }
    setProductsData() {
        const arr = DataCache.EntitlementManager.Products;
        let categories = {};
        for (let i = 0; i < arr.length; i++) {
            const prod = arr[i];
            const wObj = categories;
            this.AddToProductsCatalog(prod, wObj);
        }
        categories = this.sortingProductCatalog(categories, null, 'categories');
        let needCollapse = true;
        for (const object in categories) {
            const c = categories[object];
            if (c.Array.length > 0 && needCollapse) {
                c.IsHide = false;
                needCollapse = false;
            }
            c.SetAvaliableWidth(this.get('width') -
                (ProductsPanel.ARROW_CONTAINER_SIZE + ProductsPanel.GAP_BTW_ARROW + ProductsPanel.PADDING) * 2);
        }
        void this.set({ categories });
        this.UpdateCategoriesTextNum();
    }
    UpdateCategoriesTextNum() {
        const newValue = this.GetCachedProductCount(true);
        const newTextValue = ' (' + newValue + ')';
        void this.set({
            categoriesTextNum: newTextValue,
            noData: newValue === 0
        });
    }
    GetCachedProductCount(needRecalc) {
        if (needRecalc || this.cachedAllProductCount === null) {
            this.cachedAllProductCount = DataCache.EntitlementManager.GetProductCountByFilter(this.toolbarSelectedFilter);
        }
        return this.cachedAllProductCount;
    }
    OnAddOrUpdateProduct(product, needHistItem) {
        const categories = this.get('categories');
        let updateScroll = false;
        const belongToCurrentFilter = product.IsBelongToFilter(this.toolbarSelectedFilter);
        if (belongToCurrentFilter) {
            updateScroll = this.AddToProductsCatalog(product, categories);
        }
        else {
            updateScroll = this.RemoveFromProductsCatalog(product, categories);
        }
        void this.set('categories', categories);
        if (updateScroll) {
            this.UpdateCategoriesTextNum();
        }
        if (needHistItem) {
            this.AddHistoryItem(product);
        }
    }
    sortingProductCatalog(catalog, old, ev) {
        const keys = Object.keys(catalog);
        if (keys.length === 0) {
            return {};
        }
        const keysIndexesBeforeUpperCase = {};
        const keysUpperCase = keys.map((key) => key.toUpperCase()); // устраняем неалфавитную сортировку в случае различных регистров символов
        for (let i = 0; i < keys.length; i++) {
            keysIndexesBeforeUpperCase[keysUpperCase[i]] = i;
        }
        keysUpperCase.sort();
        const newCatalog = {};
        for (let k = 0; k < keys.length; k++) {
            const indexInKeys = keysIndexesBeforeUpperCase[keysUpperCase[k]];
            const key = keys[indexInKeys];
            newCatalog[key] = catalog[key];
        }
        void this.set(ev, newCatalog);
        return newCatalog;
    }
    AddToProductsCatalog(product, catalog) {
        if (product.ShowInSettings) // #110443 (docs paragraph 3)
         {
            return false;
        }
        let hasNewCategory = false;
        const prodCategory = isValidString(product.Category) ? product.Category : NO_NAME_CATEGORY;
        if (isNullOrUndefined(catalog[prodCategory])) {
            catalog[prodCategory] = new EntitlementCategoryProduct(prodCategory);
            hasNewCategory = true;
        }
        const filter = this.toolbarSelectedFilter;
        if (!product.IsBelongToFilter(filter)) {
            return false;
        }
        const catalogTmp = catalog[prodCategory];
        if (!catalogTmp.IsExists(product)) {
            catalogTmp.AddProduct(product);
            this.UpdateCategoriesTextNum();
        }
        return hasNewCategory;
    }
    RemoveFromProductsCatalog(product, catalog) {
        var _a;
        let isRemoved = false;
        const prodCategory = (_a = product.Category) !== null && _a !== void 0 ? _a : NO_NAME_CATEGORY;
        const category = catalog[prodCategory];
        if (!isNullOrUndefined(category)) {
            if (category.IsExists(product)) {
                category.RemoveProduct(product);
                this.UpdateCategoriesTextNum();
                isRemoved = true;
            }
            // if (category.IsEmpty())
            //     delete catalog[prodCategory];
        }
        return isRemoved;
    }
    localize() {
        super.localize();
        void this.set({
            categoriesText: Resources.getResource('screen.products.Categories'),
            // categoriesTextToolTip: Resources.getResource('screen.products.Categories.ToolTip'),
            requestText: Resources.getResource('screen.products.Request'),
            requestTextToolTip: Resources.getResource('screen.products.Request.ToolTip'),
            noDataText: Resources.getResource('screen.products.Categories.NoData')
        });
    }
    clickCheck(sender, data) {
        void this.set('checked' + data, true);
        this.addScroll();
    }
    observeActive(n, o) {
        if (!n) {
            return;
        }
        void this.set({
            checkedRequest: false
        });
    }
    observeRequest(n, o) {
        if (!isNullOrUndefined(this.quickTableRactive)) {
            void this.quickTableRactive.set('visible', n);
            void this.rangeSelectPanel.set('visible', n);
        }
        if (!n) {
            void this.set('loading', false);
            return;
        }
        void this.set({
            checkedCategories: false
        });
    }
    AddHistoryItem(product) {
        const qt = this.getQuickTable();
        if (isNullOrUndefined(qt))
            return;
        const historyItem = new EntitlementHistory(product.Id, product.Name);
        const productRequestItem = product.GenerateSubscriptionResponseMessage();
        historyItem.UpdateHistoryStatus(productRequestItem);
        qt.AddItem(new EntitlementProductsItem(historyItem, SessionSettings));
    }
    CancelBTNClick(args) {
        var _a, _b;
        if (isNullOrUndefined((_b = (_a = args === null || args === void 0 ? void 0 : args.row) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.requestData)) {
            return;
        }
        if (!isNullOrUndefined(this.myMsgBox)) {
            return;
        }
        this.myMsgBox = EntitlementManager.GetMessageBoxForProductCancelRequest(this, args.row.item.requestData);
    }
    getProductRequests(startTime, finishTime) {
        const qt = this.getQuickTable();
        if (isNullOrUndefined(qt))
            return;
        const rq = this.get('checkedRequest');
        if (rq) {
            void this.set('loading', true);
        }
        EntitlementManager.SendSubscriptionHistoryReques(new Date(startTime), new Date(finishTime)).then((msgs) => {
            if (rq) {
                void this.set('loading', false);
            }
            qt.ClearAll();
            if (msgs.length === 0) {
                return;
            }
            const fsort = (a, b) => {
                return a.ReqTime - b.ReqTime;
            };
            msgs.sort(fsort);
            for (let i = 0; i < msgs.length; i++) {
                const requestData = msgs[i];
                const product = DataCache.EntitlementManager.ProductsCache[requestData.Id];
                if (isNullOrUndefined(product)) {
                    continue;
                }
                const historyItem = new EntitlementHistory(product.Id, product.Name);
                historyItem.UpdateHistoryStatus(requestData);
                qt.AddItem(new EntitlementProductsItem(historyItem, SessionSettings));
            }
        });
    }
    onCollapserClick(sender, categoryName) {
        const cat = this.get('categories');
        const c = cat[categoryName];
        if (!isNullOrUndefined(c)) {
            c.IsHide = !c.IsHide;
        }
        void this.set('categories', cat);
        if (!c.IsHide) {
            this.scrollTo(c.Name);
        }
    }
    scrollingLeftClick(sender, categoryName) {
        const cat = this.get('categories');
        if (!isNullOrUndefined(cat[categoryName])) {
            cat[categoryName].LeftArrowClick();
        }
        void this.set('categories', cat);
    }
    scrollingRightClick(sender, categoryName) {
        const cat = this.get('categories');
        if (!isNullOrUndefined(cat[categoryName])) {
            cat[categoryName].RightArrowClick();
        }
        void this.set('categories', cat);
    }
    createToolbar() {
        this.fillFilterComboBox();
        this.on('onSelectedFilterValueChange', this.onSelectedFilterValueChanged);
    }
    fillFilterComboBox() {
        const filterComboBox = !isNullOrUndefined(this.Controls) ? this.Controls.filterComboBox : null;
        if (isNullOrUndefined(filterComboBox)) {
            return;
        }
        const isAddFilter = (entitlementProductFilter) => {
            switch (entitlementProductFilter) {
                case EntitlementProductFilter.All:
                case EntitlementProductFilter.Subscribed:
                case EntitlementProductFilter.AvailableForSubscription:
                case EntitlementProductFilter.Processing:
                    return true;
                default:
                    return false;
            }
        };
        const items = createContextMenuItemsFromEnum(EntitlementProductFilter, getEntitlementProductFilterKey, isAddFilter);
        const sortOrder = [
            EntitlementProductFilter.All,
            EntitlementProductFilter.Subscribed,
            EntitlementProductFilter.AvailableForSubscription,
            EntitlementProductFilter.Processing,
            EntitlementProductFilter.SubscribedAndProcessing,
            EntitlementProductFilter.NotSubscribedButProcessing
        ];
        items.sort((a, b) => {
            const indexA = sortOrder.indexOf(a.value);
            const indexB = sortOrder.indexOf(b.value);
            return indexA - indexB;
        });
        filterComboBox.set({ items });
    }
    dispose() {
        var _a;
        DataCache.EntitlementManager.OnAddOrUpdate.UnSubscribe(this.OnAddOrUpdateProduct, this);
        this.rangeSelectPanel.getReportEvent.UnSubscribe(this.getProductRequests, this);
        (_a = this.scroll) === null || _a === void 0 ? void 0 : _a.destroy();
        super.dispose();
    }
    AttachClick(clickedItem) {
        if (this.get('attached')) {
            const newPanel = MainWindowManager.Factory.createPanel(PanelNames.ProductsPanel);
            void newPanel.set({ dockablePanel: false, showHeader: true, resizable: true });
            MainWindowManager.Factory.dockSystemOperations(newPanel, false);
            MainWindowManager.Factory.addPanelToWs(newPanel);
        }
        else {
            void this.set({ dockablePanel: true, showHeader: false, resizable: false });
            DockSystemInstance.addPanelOnDock(this, DockPlaceConst.Middle, false);
            WorkSpaceManager.currentWorkspace.addPanel(this);
        }
    }
    addScroll() {
        this.scroll = HtmlScroll.addScroll(this.find('.js-products-main'));
    }
    removeScroll() {
        var _a;
        (_a = this.scroll) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    resetScroll() {
        this.removeScroll();
        this.addScroll();
    }
    scrollTo(elementID) {
        if (!isValidString(elementID) || elementID === NO_NAME_CATEGORY) {
            return;
        }
        const productsMain = this.find('.js-products-main');
        const element = productsMain.querySelector(`#${CSS.escape(elementID)}`);
        element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    Properties() {
        const properties = super.Properties();
        // properties.push(new DynProperty("attached", this.get("dockablePanel"), DynProperty.BOOLEAN, DynProperty.HIDDEN_GROUP));
        properties.push(new DynProperty('toolbarSelectedFilter', this.toolbarSelectedFilter, DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
        return properties;
    }
    callBack(newProperties) {
        super.callBack(newProperties);
        this.toolbarSelectedFilter = DynProperty.getPropValue(newProperties, 'toolbarSelectedFilter');
        // let attached = DynProperty.getPropValue(newProperties, "attached");
        // this.set({ dockablePanel: attached, showHeader: !attached })
        // if (!attached)
        // {
        //     this.unrender()
        //     Factory.dockSystemOperations(this, false);
        //     Factory.addPanelToWs(this);
        // }
    }
}
ProductsPanel.HEADER_PANEL = 56;
ProductsPanel.SWITCH_MENU = 32;
ProductsPanel.TOOLBAR_HEIGHT = 48;
ProductsPanel.ARROW_CONTAINER_SIZE = 32;
ProductsPanel.GAP_BTW_ARROW = 8;
ProductsPanel.PADDING = 16;
ApplicationPanelWithTable.extendWith(ProductsPanel, {
    data: function () {
        return {
            width: 802,
            height: 551,
            movable: true,
            resizable: false,
            showHeader: true,
            showFooter: false,
            focused: true,
            dockablePanel: false,
            attached: false,
            canLinkByAccount: false,
            heightSubscriptionsPanel: null,
            heightRequestTopPanel: ProductsPanel.TOOLBAR_HEIGHT,
            categoriesText: '', // локазирированное название вкладки Subscriptions
            categoriesTextNum: '', // общее кол-во продуктов в заглавии вкладки с учетом фильтра вместе со скобками
            noData: false,
            noDataText: '',
            noDataImg: 'subscriptionsIcon',
            checkedCategories: true,
            checkedRequest: false,
            categories: {}
        };
    },
    partials: {
        bodyPartial: TerceraProductsPanelTemplate,
        noDataPart: PanelSideBarBaseNoDataPartial
    }
});
